import {AxiosError} from 'axios';
import {has, isNil} from 'ramda';
import {ApplicationError} from './ApplicationError';
import {ErrorCode} from './ErrorCode';
import {ApplicationErrorCode} from './ApplicationErrorCode';

const map = new Map<ApplicationErrorCode, ErrorCode>;
map.set(ApplicationErrorCode.INVALID_BULK_UPLOAD_LICENSES, ErrorCode.INVALID_BULK_UPLOAD);
map.set(ApplicationErrorCode.INVALID_PERMISSIONS, ErrorCode.INVALID_PERMISSIONS);
map.set(ApplicationErrorCode.BULK_UPLOAD_PARSE_ERROR_GENERIC, ErrorCode.BULK_UPLOAD_PARSE_ERROR_GENERIC);
map.set(ApplicationErrorCode.BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS, ErrorCode.BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS);
map.set(ApplicationErrorCode.BULK_UPLOAD_MAX_RECORD_SIZE, ErrorCode.BULK_UPLOAD_MAX_RECORD_SIZE);
map.set(ApplicationErrorCode.BULK_UPLOAD_INCONSISTENT_COLUMNS, ErrorCode.BULK_UPLOAD_INCONSISTENT_COLUMNS);

export const makeGenericApplicationError = (error: AxiosError) => {
  if (!isNil(error.response) && has('errorCode', error.response.data) && typeof error.response.data.errorCode == 'number') {
    const code = map.get(error.response.data.errorCode);
    if (code) {
      return new ApplicationError('Generic application error', code)
    }
  }

  return new ApplicationError('Unknown Error', ErrorCode.UNKNOWN);
};
